import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import swal from 'sweetalert2';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class AdminService {

  constructor(private http: HttpClient) { }

  activate_user(id: number, activate: boolean) {
    return this.http.post(environment.Api_get_user_activate, {
      user_id: id,
      active: activate,
    });
  }


  Update(id: number) {
    return this.http.post(`${environment.UpdatePointMedic}${id}/`, {});
  }

  enviarMensajeMasivo(data) {
    return this.http.post(environment.Api_enviar_mensaje_masivo, data);
  }

  getListaCanales() {
    return this.http.get(environment.Api_get_channels);
  }

  getListaTipoMensaje() {
    return this.http.get(environment.Api_message_type);
  }

  medicos_referidos_mes(year: any, id: any) {
    return this.http.get(
      environment.Api_medic_graphics + year + '/' + id + '/'
    );
  }

  comerciales_referidos_mes(year: any, id: any) {
    return this.http.get(
      environment.Api_comercial_graphics + year + '/' + id + '/'
    );
  }


  listPopups(page: number = 1, pageSize: number = 10, active?: boolean, targetUsers?: string, search?: string): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', pageSize.toString());

    if (active !== undefined) {
      params = params.set('active', active.toString());
    }

    if (targetUsers && targetUsers !== '') {
      params = params.set('target_users', targetUsers);
    }

    if (search && search.trim() !== '') {
      params = params.set('search', search.trim());
    }

    return this.http.get(environment.Api_popups_list, { params });
  }

  // Crear popup
  createPopup(popupData: {
    name: string;
    title: string;
    content: string;
    image?: string;
    start_date: string;
    end_date: string;
    popup_type: string;
    frequency: string;
    target_users: string;
    specialties?: number[];
    is_modal: boolean;
    auto_close: boolean;
    auto_close_seconds?: number;
    primary_button_text: string;
    primary_button_url?: string;
    secondary_button_text?: string;
    secondary_button_url?: string;
    active: boolean;
    priority: number;
  }): Observable<any> {
    return this.http.post(environment.Api_create_popup, popupData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  // Obtener popup específico
  getPopup(popupId: number): Observable<any> {
    return this.http.get(`${environment.Api_popup_detail}${popupId}/`);
  }

  // Actualizar popup
  updatePopup(popupId: number, updateData: any): Observable<any> {
    return this.http.patch(`${environment.Api_popup_detail}${popupId}/`, updateData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  // Eliminar popup
  deletePopup(popupId: number): Observable<any> {
    return this.http.delete(`${environment.Api_popup_detail}${popupId}/`);
  }

  // Obtener especialidades (para filtros)
  getSpecialties(): Observable<any> {
    return this.http.get(environment.Api_get_especialties2);
  }

  // Activar/desactivar popup
  togglePopupStatus(popupId: number, active: boolean): Observable<any> {
    return this.updatePopup(popupId, { active });
  }


  // Métodos actualizados para banners en admin.service.ts

  // Listar banners con nueva API
  listBanners(page: number = 1, pageSize: number = 10, active?: boolean, search?: string) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', pageSize.toString());

    if (active !== undefined) {
      params = params.set('active', active.toString());
    }

    if (search && search.trim() !== '') {
      params = params.set('search', search.trim());
    }

    return this.http.get(environment.Api_banners_list, { params });
  }

  // Crear banner usando FormData (preferido)
  createBannerFormData(bannerData: {
    name: string;
    title: string;
    description: string;
    imageWeb: File;
    imageMobile: File;
    startDate: string;
    endDate: string;
    order: number;
    active: boolean;
    bannerType: string;
    linkUrl?: string;
    linkText?: string;
    displayDuration?: number;
  }) {
    const formData = new FormData();

    formData.append('name', bannerData.name);
    formData.append('title', bannerData.title);
    formData.append('description', bannerData.description);
    formData.append('image_web', bannerData.imageWeb);
    formData.append('image_mobile', bannerData.imageMobile);
    formData.append('start_date', bannerData.startDate);
    formData.append('end_date', bannerData.endDate);
    formData.append('order', bannerData.order.toString());
    formData.append('active', bannerData.active.toString());
    formData.append('banner_type', bannerData.bannerType);

    if (bannerData.linkUrl) {
      formData.append('link_url', bannerData.linkUrl);
    }

    if (bannerData.linkText) {
      formData.append('link_text', bannerData.linkText);
    }

    if (bannerData.displayDuration) {
      formData.append('display_duration', bannerData.displayDuration.toString());
    }

    return this.http.post(environment.Api_create_banner, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  // Obtener banner específico
  getBanner(bannerId: number) {
    return this.http.get(`${environment.Api_banner_detail}${bannerId}/`);
  }

  // Actualizar banner usando PATCH
  updateBanner(bannerId: number, updateData: any) {
    return this.http.patch(`${environment.Api_banner_detail}${bannerId}/`, updateData);
  }

  // Actualizar banner con FormData (para cuando hay archivos)
  updateBannerFormData(bannerId: number, bannerData: {
    name: string;
    title: string;
    description: string;
    imageWeb?: File;
    imageMobile?: File;
    startDate: string;
    endDate: string;
    order: number;
    active: boolean;
    bannerType: string;
    linkUrl?: string;
    linkText?: string;
    displayDuration?: number;
  }) {
    const formData = new FormData();

    formData.append('name', bannerData.name);
    formData.append('title', bannerData.title);
    formData.append('description', bannerData.description);
    formData.append('start_date', bannerData.startDate);
    formData.append('end_date', bannerData.endDate);
    formData.append('order', bannerData.order.toString());
    formData.append('active', bannerData.active.toString());
    formData.append('banner_type', bannerData.bannerType);

    if (bannerData.imageWeb) {
      formData.append('image_web', bannerData.imageWeb);
    }

    if (bannerData.imageMobile) {
      formData.append('image_mobile', bannerData.imageMobile);
    }

    if (bannerData.linkUrl) {
      formData.append('link_url', bannerData.linkUrl);
    }

    if (bannerData.linkText) {
      formData.append('link_text', bannerData.linkText);
    }

    if (bannerData.displayDuration) {
      formData.append('display_duration', bannerData.displayDuration.toString());
    }

    return this.http.patch(`${environment.Api_banner_detail}${bannerId}/`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  // Eliminar banner
  deleteBanner(bannerId: number) {
    return this.http.delete(`${environment.Api_banner_detail}${bannerId}/`);
  }

  // Método legacy para mantener compatibilidad (deprecated)
  banner_id(id: number) {
    return this.getBanner(id);
  }

  // Método legacy para mantener compatibilidad (deprecated)
  delete_banner(banner_id: number) {
    return this.deleteBanner(banner_id);
  }

  // Método legacy para mantener compatibilidad (deprecated)
  updateStateBanner(banner_id: number, activate: boolean) {
    return this.updateBanner(banner_id, { active: activate });
  }




  specialties_list() {
    return this.http.get(environment.Api_get_especialties2);
  }

  create_survey(
    title: string,
    description: string,  // Agregar este parámetro
    all_medics: Boolean,
    recipients_specialties: any
  ) {
    return this.http.post(environment.Api_create_survey, {
      title,
      description,  // Agregar en el body
      all_medics,
      recipients_specialties,
    });
  }

  create_question(survey_id, items) {
    return this.http.post(environment.Api_create_question + '/', {
      survey_id,
      items,
    });
  }

  list_idSurvey(survey_id: number) {
    return this.http.get(environment.Api_list_survey + survey_id);
  }

  list_surveys(
    filtro: any,
    param: any,
    orden: number,
    direccion: number,
    page: number
  ) {
    return this.http.get(
      environment.Api_admin_list_surveys +
      '/' +
      filtro +
      '/' +
      param +
      '/' +
      orden +
      '/' +
      direccion +
      '/' +
      page
    );
  }

  list_active_surgeons(commercialID, paginationID) {
    return this.http.get(
      environment.Api_get_all_commercial_active_list +
      commercialID +
      '/' +
      paginationID
    );
  }

  create_survey_answer(question_id: number, answer: any) {
    console.log(answer);
    return this.http.post(environment.Api_create_answer, {
      question_id: question_id,
      answers: [answer],
    });
  }

  edit_survey_answer(answer_id: number, answer: string) {
    console.log(answer);
    return this.http.post(environment.Api_update_survey_answer, {
      answer: { id: answer_id, answer: answer },
    });
  }

  edit_survey_title(survey_id: number, title: string) {
    return this.http.post(environment.Api_update_survey_title, {
      title: { id: survey_id, title: title },
    });
  }

  edit_survey_description(survey_id: number, descr: string) {
    return this.http.post(environment.Api_update_survey_description, {
      survey_id: survey_id,
      description: descr,
    });
  }

  delete_survey_answer(answer_id: number) {
    return this.http.post(environment.Api_delete_survey_answer, {
      answer_id: answer_id,
    });
  }

  delete_survey(survey_id: number) {
    return this.http.post(environment.Api_delete_survey, {
      survey_id: survey_id,
    });
  }

  delete_question(question_id: number) {
    return this.http.post(environment.Api_delete_question, {
      question_id: question_id,
    });
  }

  toggleActivateSurvey(id_survey, status) {
    return this.http.post(environment.Api_toggle_activate_survey, {
      survey_id: id_survey,
      active: status,
    });
  }

  activar_referral_check_7(enable) {
    return this.http.post(environment.Api_activar_referral_check_7, {
      enable: enable,
    });
  }

  activar_monthly_inactive_check(enable) {
    return this.http.post(environment.API_MARCAR_USUARIOS_INACTIVOs_STATUS, {
      enable: enable,
    });
  }

  activar_unused_code_30(enable) {
    return this.http.post(environment.Api_activar_unused_code_30, {
      enable: enable,
    });
  }

  activar_reward_available_check(enable) {
    return this.http.post(environment.Api_activar_reward_available_check, {
      enable: enable,
    });
  }

  get_notification_status() {
    return this.http.get(environment.Api_get_notification_status);
  }

  add_city(id, descripcion) {
    return this.http.post(environment.Api_add_city, {
      city_id: id,
      description: descripcion,
    });
  }

  getFilteredUsers(params: any) {
    return this.http.get<any[]>(environment.Api_getUsuarioSerch, { params });
  }


  sendNotification(data: any) {
    return this.http.post(environment.Api_send_notification, data);
  }

  sendScheduledNotification(data: any) {
    return this.http.post(environment.Api_send_scheduled_notification, data);
  }

  delete_city(id) {
    return this.http.post(environment.Api_delete_city, { city_id: id });
  }

  get_admin_list(filter, parameter, order, direction, page_number) {
    return this.http.get(
      environment.Api_get_admin_list +
      filter +
      '/' +
      parameter +
      '/' +
      order +
      '/' +
      direction +
      '/none/none/' +
      page_number
    );
  }

  resend_credentials(id) {
    return this.http.post(environment.Api_admin_resend_credentials, {
      user_id: id,
    });
  }

  view_medic_redemptions(id, page) {
    return this.http.get(
      environment.Api_view_medic_redemptions + id + '/' + page
    );
  }

  get_logs(order, direction, user_id, action_id, page) {
    return this.http.get(
      environment.Api_get_logs +
      order +
      '/' +
      direction +
      '/' +
      user_id +
      '/' +
      action_id +
      '/' +
      page +
      '/'
    );
  }

  city_pool_list() {
    return this.http.get(environment.Api_pool_cities);
  }

  load_stats(year, city) {
    return this.http.get(environment.Api_admin_stats + year + '/' + city + '/');
  }

  get_achievement() {
    return this.http.get(environment.Api_admin_get_achievement);
  }

  edit_achievement(id, required_points) {
    return this.http.post(environment.Api_admin_edit_achievement, {
      achievement_id: id,
      required_points: required_points,
    });
  }

  medic_details(id) {
    return this.http.get(environment.Api_admin_medic_details + id + '/');
  }

  list_ciudades() {
    return this.http.get(environment.Api_all_cities);
  }

  create_admin(
    first_name: string,
    first_name2: string,
    last_name: string,
    last_name2: string,
    email: string,
    cell: string,
    dni: string,
    city_id: string
  ) {
    var role = 'admin';
    return this.http.post(environment.Api_admin_register, {
      first_name,
      last_name,
      first_name2,
      last_name2,
      email,
      cell,
      role,
      dni,
      city_id,
    });
  }

  editComercial(
    comercialID,
    firstName,
    secondName,
    lastName,
    secondLastName,
    email,
    cellphone,
    dni,
    city,
    isActive
  ) {
    var data = {
      first_name: firstName,
      first_name2: secondName,
      last_name: lastName,
      last_name2: secondLastName,
      email: email,
      cell: cellphone,
      dni: dni,
      city: city,
      active: isActive,
      country_code: '57',
    };
    return this.http.post(
      environment.API_UPDATE_COMERCIAL_DATA + comercialID + '/',
      data
    );
  }

  edit_admin(
    user_id,
    first_name: string,
    first_name2: string,
    last_name: string,
    last_name2: string,
    email: string,
    cell: string,
    dni: string,
    city: string,
    active: string
  ) {
    var data = {
      first_name: first_name,
      first_name2: first_name2,
      last_name: last_name,
      last_name2: last_name2,
      email: email,
      cell: cell,
      dni: dni,
      city: city,
      active: active,
      country_code: '57',
    };
    return this.http.post(
      environment.Api_post_user_details + user_id + '/',
      data
    );
  }

  getMetas(page, search) {
    let params = '?page=' + page + (search ? '&search=' + search : '');
    return this.http.get(environment.ListarMetas + params);
  }

  getMetaDetail(id) {
    return this.http.get(environment.MetasDetail + id + '/');
  }

  getCampaing(params: any) {
    return this.http.get(environment.campaingMefid, { params });
  }

  PutMetaDetail(
    magnitude_type,
    metric,
    operator,
    is_active,
    magnitude,
    value,
    name
  ) {
    const body = {
      magnitude_type: magnitude_type,
      metric: metric,
      operator: operator,
      is_active: is_active,
      magnitude: magnitude,
      value: value,
      name: name,
    };

    return this.http.put(environment.MetasDetail, body);
  }

  logroUpdate(
    id,
    magnitude_type,
    metric,
    operator,
    is_active,
    magnitude,
    value,
    name,
    date_start,
    date_end,
    levels?: any[]
  ) {
    let body: any = {
      magnitude_type: magnitude_type,
      metric: metric,
      operator: operator,
      is_active: is_active,
      name: name,
      date_start: date_start,
      date_end: date_end,
    };

    // Si tiene levels, es una meta escalada
    if (levels && levels.length > 0) {
      body.levels = levels;
      // Para metas escaladas, no incluir magnitude y value individuales
    } else {
      // Para metas normales, incluir magnitude y value
      body.magnitude = magnitude;
      body.value = value;
    }

    return this.http.put(environment.editMeta + `/${id}` + '/', body);
  }

  registroMetas(page, search, goals) {
    let params =
      '?page=' +
      page +
      (search ? '&search=' + search : '') +
      (goals ? '&goals=' + goals : '');
    return this.http.get(environment.registroMetas + params);
  }

  returnMessages(
    page,
    message_id__title__icontains,
    medic_id__user_id__dni__icontains,
    message_id__date_created,
    message_id__date_created__gte,
    message_id__date_created__lte
  ) {
    let params =
      '?page=' +
      page +
      (message_id__title__icontains
        ? '&message_id__title__icontains=' + message_id__title__icontains
        : '') +
      (medic_id__user_id__dni__icontains
        ? '&medic_id__user_id__dni__icontains=' +
        medic_id__user_id__dni__icontains
        : '') +
      (message_id__date_created
        ? '&message_id__date_created=' + message_id__date_created
        : '') +
      (message_id__date_created__gte
        ? '&message_id__date_created__gte=' + message_id__date_created__gte
        : '') +
      (message_id__date_created__lte
        ? '&message_id__date_created__lte=' + message_id__date_created__lte
        : '');
    return this.http.get(environment.Api_get_all_message + params);
  }

  registroAsistente(id, start, end) {
    let params =
      '/' +
      id +
      (start ? '&start=' + encodeURIComponent(start) : '') +
      (end ? '&end=' + encodeURIComponent(end) : '');
    return this.http.get(environment.registroAsistentes + params + '/');
  }

  Asistentes(id, start, end) {
    let params =
      '/' +
      id +
      (start ? '&start=' + encodeURIComponent(start) : '') +
      (end ? '&end=' + encodeURIComponent(end) : '');
    return this.http.get(environment.asistentes + params);
  }

  referidoAsistente(page, start, end, search) {
    let params =
      '?page=' +
      page +
      (start ? '&start=' + encodeURIComponent(start) : '') +
      (end ? '&end=' + encodeURIComponent(end) : '') +
      (search ? '&search=' + search : '');
    return this.http.get(environment.referirAsistente + params);
  }

  crearMeta(...args: any[]) {
    let body: any;

    // Si el primer argumento es un objeto y el segundo es boolean (nueva firma)
    if (args.length === 2 && typeof args[0] === 'object' && typeof args[1] === 'boolean') {
      const [metaData, isEscalada] = args;

      if (isEscalada) {
        // Estructura para meta escalada
        body = {
          name: metaData.name,
          metric: metaData.metric,
          operator: metaData.operator,
          magnitude_type: metaData.magnitude_type,
          date_start: metaData.date_start,
          date_end: metaData.date_end,
          is_active: metaData.is_active,
          levels: metaData.levels
        };
      } else {
        // Estructura para meta normal desde objeto
        body = {
          magnitude_type: metaData.magnitude_type,
          metric: metaData.metric,
          operator: metaData.operator,
          is_active: metaData.is_active,
          magnitude: metaData.magnitude,
          value: metaData.value,
          name: metaData.name,
          date_start: metaData.date_start,
          date_end: metaData.date_end,
        };
      }
    }
    // Mantiene la firma original para compatibilidad hacia atrás (9 parámetros)
    else if (args.length === 9) {
      const [magnitude_type, metric, operator, is_active, magnitude, value, name, date_start, date_end] = args;
      body = {
        magnitude_type: magnitude_type,
        metric: metric,
        operator: operator,
        is_active: is_active,
        magnitude: magnitude,
        value: value,
        name: name,
        date_start: date_start,
        date_end: date_end,
      };
    }

    return this.http.post(environment.CrearMeta, body);
  }

  list_comerciales() {
    return this.http.get(environment.ListComercialAdmin);
  }

  getComercialActual(id) {
    let params = id;
    return this.http.get(environment.saberComercial + params);
  }

  UpdateComercial(id, userId) {
    let params = id;

    const url =
      `${environment.editComercialByAdmin}update/${params}/${userId}` + '/';

    const body = {
      user_id: userId,
    };

    return this.http.put(url, body);
  }

  // Agregar estos métodos al AdminService existente

  // === MÉTODOS PARA ALIANZAS ===

  // Listar alianzas
  listAlliances(page: number = 1, pageSize: number = 10, active?: boolean, search?: string): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', pageSize.toString());

    if (active !== undefined) {
      params = params.set('active', active.toString());
    }

    if (search && search.trim() !== '') {
      params = params.set('search', search.trim());
    }

    return this.http.get(environment.Api_alliances_list, { params });
  }

  // Crear alianza
  createAlliance(allianceData: {
    name: string;
    description: string;
    laboratory_id: number;
    status: number;
    is_multicommercial: boolean;
    is_switcheable: boolean;
    start_date: string;
    end_date?: string;
  }): Observable<any> {
    return this.http.post(environment.Api_create_alliance, allianceData);
  }

  // Obtener alianza específica
  getAlliance(allianceId: number): Observable<any> {
    return this.http.get(`${environment.Api_alliance_detail}${allianceId}/`);
  }

  // Actualizar alianza
  updateAlliance(allianceId: number, updateData: any): Observable<any> {
    return this.http.put(`${environment.Api_alliance_detail}${allianceId}/`, updateData);
  }

  // Eliminar alianza
  deleteAlliance(allianceId: number): Observable<any> {
    return this.http.delete(`${environment.Api_alliance_detail}${allianceId}/`);
  }

  // Obtener lista de laboratorios (para el select)
  getLaboratories(): Observable<any> {
    return this.http.get(environment.API_GET_LABS);
  }


  getPopupAnalytics(year?: string, startDate?: string, endDate?: string): Observable<any> {
    let params = new HttpParams();

    if (year) {
      params = params.set('year', year);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    return this.http.get(`${environment.Api_analytics_popups}`, { params });
  }

  /**
   * Obtener analíticas de un popup específico
   * @param popupId ID del popup
   * @param year Año para filtrar los datos
   * @param startDate Fecha de inicio (opcional)
   * @param endDate Fecha de fin (opcional)
   */
  getPopupAnalyticsById(popupId: number, year?: string, startDate?: string, endDate?: string): Observable<any> {
    let params = new HttpParams().set('popup_id', popupId.toString());

    if (year) {
      params = params.set('year', year);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    return this.http.get(`${environment.Api_analytics_popups}`, { params });
  }

  /**
   * Obtener analíticas generales de banners
   * @param year Año para filtrar los datos
   * @param startDate Fecha de inicio (opcional)
   * @param endDate Fecha de fin (opcional)
   */
  getBannerAnalytics(year?: string, startDate?: string, endDate?: string): Observable<any> {
    let params = new HttpParams();

    if (year) {
      params = params.set('year', year);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    return this.http.get(`${environment.Api_analytics_banners}`, { params });
  }

  /**
   * Obtener analíticas de un banner específico
   * @param bannerId ID del banner
   * @param year Año para filtrar los datos
   * @param startDate Fecha de inicio (opcional)
   * @param endDate Fecha de fin (opcional)
   */
  getBannerAnalyticsById(bannerId: number, year?: string, startDate?: string, endDate?: string): Observable<any> {
    let params = new HttpParams().set('banner_id', bannerId.toString());

    if (year) {
      params = params.set('year', year);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    return this.http.get(`${environment.Api_analytics_banners}`, { params });
  }

  /**
   * Obtener analíticas comparativas entre popups y banners
   * @param year Año para filtrar los datos
   * @param startDate Fecha de inicio (opcional)
   * @param endDate Fecha de fin (opcional)
   */
  getComparativeAnalytics(year?: string, startDate?: string, endDate?: string): Observable<any> {
    let params = new HttpParams();

    if (year) {
      params = params.set('year', year);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    // Asumiendo que existe un endpoint para comparativas
    return this.http.get(`${environment.Api_analytics_comparative}`, { params });
  }

  /**
   * Obtener resumen de métricas de rendimiento
   * @param type Tipo de elemento ('popup' | 'banner' | 'all')
   * @param period Período de tiempo ('week' | 'month' | 'year')
   */
  getPerformanceMetrics(type: string = 'all', period: string = 'month'): Observable<any> {
    const params = new HttpParams()
      .set('type', type)
      .set('period', period);

    return this.http.get(`${environment.Api_analytics_performance}`, { params });
  }

  /**
   * Obtener datos de engagement por elemento
   * @param elementType Tipo de elemento ('popup' | 'banner')
   * @param elementId ID del elemento (opcional)
   * @param dateRange Rango de fechas
   */
  getEngagementData(elementType: string, elementId?: number, dateRange?: { start: string, end: string }): Observable<any> {
    let params = new HttpParams().set('element_type', elementType);

    if (elementId) {
      params = params.set('element_id', elementId.toString());
    }

    if (dateRange) {
      params = params.set('start_date', dateRange.start);
      params = params.set('end_date', dateRange.end);
    }

    return this.http.get(`${environment.Api_analytics_engagement}`, { params });
  }

  /**
   * Obtener datos de conversión por funnel
   * @param elementType Tipo de elemento ('popup' | 'banner')
   * @param elementId ID del elemento (opcional)
   * @param year Año para filtrar
   */
  getConversionFunnel(elementType: string, elementId?: number, year?: string): Observable<any> {
    let params = new HttpParams().set('element_type', elementType);

    if (elementId) {
      params = params.set('element_id', elementId.toString());
    }

    if (year) {
      params = params.set('year', year);
    }

    return this.http.get(`${environment.Api_analytics_conversion}`, { params });
  }

  /**
   * Exportar datos de analíticas a Excel
   * @param type Tipo de reporte ('popup' | 'banner' | 'comparative')
   * @param filters Filtros aplicados
   */
  exportAnalyticsData(type: string, filters: any): Observable<Blob> {
    const params = new HttpParams()
      .set('type', type)
      .set('filters', JSON.stringify(filters));

    return this.http.get(`${environment.Api_analytics_export}`, {
      params,
      responseType: 'blob'
    });
  }

  /**
   * Obtener configuración de alertas de rendimiento
   */
  getPerformanceAlerts(): Observable<any> {
    return this.http.get(`${environment.Api_analytics_alerts}`);
  }

  /**
   * Configurar alertas de rendimiento
   * @param alertConfig Configuración de la alerta
   */
  setPerformanceAlert(alertConfig: {
    element_type: string;
    element_id?: number;
    metric: string;
    threshold: number;
    condition: string;
    notification_email: string;
    active: boolean;
  }): Observable<any> {
    return this.http.post(`${environment.Api_analytics_alerts}`, alertConfig);
  }

  /**
   * Obtener datos de heatmap para elementos
   * @param elementType Tipo de elemento
   * @param elementId ID del elemento
   * @param dateRange Rango de fechas
   */
  getHeatmapData(elementType: string, elementId: number, dateRange: { start: string, end: string }): Observable<any> {
    const params = new HttpParams()
      .set('element_type', elementType)
      .set('element_id', elementId.toString())
      .set('start_date', dateRange.start)
      .set('end_date', dateRange.end);

    return this.http.get(`${environment.Api_analytics_heatmap}`, { params });
  }

  /**
   * Obtener datos de audiencia y segmentación
   * @param elementType Tipo de elemento
   * @param elementId ID del elemento (opcional)
   * @param segmentBy Criterio de segmentación
   */
  getAudienceData(elementType: string, elementId?: number, segmentBy?: string): Observable<any> {
    let params = new HttpParams().set('element_type', elementType);

    if (elementId) {
      params = params.set('element_id', elementId.toString());
    }

    if (segmentBy) {
      params = params.set('segment_by', segmentBy);
    }

    return this.http.get(`${environment.Api_analytics_audience}`, { params });
  }

  /**
   * Obtener datos de retención y frecuencia
   * @param elementType Tipo de elemento
   * @param period Período de análisis
   */
  getRetentionData(elementType: string, period: string = 'month'): Observable<any> {
    const params = new HttpParams()
      .set('element_type', elementType)
      .set('period', period);

    return this.http.get(`${environment.Api_analytics_retention}`, { params });
  }



  listAllianceAdministrators(page: number = 1, pageSize: number = 10, active?: boolean, search?: string): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', pageSize.toString());

    if (active !== undefined) {
      params = params.set('active', active.toString());
    }

    if (search && search.trim() !== '') {
      params = params.set('search', search.trim());
    }

    return this.http.get(environment.Api_alliance_administrators_list, { params });
  }

  /**
   * Crear administrador de alianza usando la ruta especial
   */
  createAllianceAdministrator(
    first_name: string,
    first_name2: string,
    last_name: string,
    last_name2: string,
    email: string,
    cell: string,
    dni: string,
    city_id: string,
    alliance_id: number,
    permission_level: number
  ): Observable<any> {
    const payload = {
      first_name,
      first_name2,
      last_name,
      last_name2,
      email,
      cell,
      dni,
      city_id,
      role: 'alliance',
      alliance_id,
      permission_level,
    };

    return this.http.post(environment.Api_comercial_register, payload);
  }

  /**
   * Obtener administrador específico de alianza
   */
  getAllianceAdministrator(id: number): Observable<any> {
    return this.http.get(`${environment.Api_alliance_administrators_detail}${id}/`);
  }

  /**
   * Actualizar administrador de alianza
   */
  updateAllianceAdministrator(
    id: number,
    user_id: number,
    alliance_id: number,
    permission_level: number,
    is_active: boolean
  ): Observable<any> {
    const payload = {
      user_id,
      alliance_id,
      permission_level,
      is_active,
    };

    return this.http.put(`${environment.Api_alliance_administrators_detail}${id}/`, payload);
  }

  /**
   * Eliminar administrador de alianza
   */
  deleteAllianceAdministrator(id: number): Observable<any> {
    return this.http.delete(`${environment.Api_alliance_administrators_detail}${id}/`);
  }

  /**
   * Activar/desactivar administrador de alianza
   */
  toggleAllianceAdministratorStatus(id: number, is_active: boolean): Observable<any> {
    return this.updateAllianceAdministrator(id, 0, 0, 0, is_active); // Solo actualiza el estado
  }

  createSurveyNew(surveyData: CreateSurveyRequest): Observable<any> {
    return this.http.post(environment.Api_create_survey_new, surveyData);
  }

  /**
   * Listar encuestas con la nueva API
   */
  listSurveysNew(filter?: string, param?: string, order?: number, direction?: number, page?: number): Observable<any> {
    const filterValue = filter || 'none';
    const paramValue = param || 'none';
    const orderValue = order || 0;
    const directionValue = direction || 0;
    const pageValue = page || 1;

    // Usar la ruta existente del environment
    const url = `${environment.Api_admin_list_surveys}/${filterValue}/${paramValue}/${orderValue}/${directionValue}/${pageValue}/`;

    return this.http.get(url);
  }

  /**
   * Obtener detalles de encuesta con la nueva API
   */
  getSurveyDetailsNew(surveyId: number): Observable<SurveyDetails> {
    return this.http.get<SurveyDetails>(`${environment.Api_survey_details_new}${surveyId}/`);
  }

  /**
   * Obtener estadísticas de encuesta
   */
  getSurveyStatistics(surveyId: number): Observable<SurveyStatistics> {
    return this.http.get<SurveyStatistics>(`${environment.Api_survey_statistics_new}${surveyId}/`);
  }

  /**
   * Activar/desactivar encuesta con la nueva API
   */
  toggleSurveyStatusNew(surveyId: number, active: boolean): Observable<any> {
    return this.http.post(environment.Api_activate_survey_new, {
      survey_id: surveyId,
      active: active
    });
  }

  /**
   * Eliminar encuesta con la nueva API
   */
  deleteSurveyNew(surveyId: number): Observable<any> {
    return this.http.post(environment.Api_delete_survey_new, {
      survey_id: surveyId
    });
  }

  /**
   * Agregar preguntas a encuesta con la nueva API
   */
  addSurveyQuestionsNew(questionData: CreateQuestionRequest): Observable<any> {
    return this.http.post(environment.Api_add_survey_question_new, questionData);
  }

  /**
   * Editar título de encuesta
   */
  editSurveyTitleNew(surveyId: number, title: string): Observable<any> {
    return this.http.post(environment.Api_edit_survey_title_new, {
      title: {
        id: surveyId.toString(),
        title: title
      }
    });
  }

  /**
   * Editar descripción de encuesta
   */
  editSurveyDescriptionNew(surveyId: number, description: string): Observable<any> {
    return this.http.post(environment.Api_edit_survey_description_new, {
      survey_id: surveyId,
      description: description
    });
  }


  edit_survey_question(question_id: number, question_text: string, question_type: string) {
    return this.http.post(environment.Api_update_survey_question, {
      question: {
        id: question_id,           // ID como número
        question: question_text,   // Texto de la pregunta
        question_type: question_type // Tipo de pregunta
      }
    });
  }

  editSurveyQuestionNew(questionId: number, question_text: string, question_type: string): Observable<any> {
    return this.http.post(environment.Api_edit_survey_question_new, {
      question: {
        id: questionId,            // ID como número
        question: question_text,   // Texto de la pregunta
        question_type: question_type // Tipo de pregunta
      }
    });
  }

  /**
   * Editar respuesta de encuesta
   */
  editSurveyAnswerNew(answerId: number, answer: string): Observable<any> {
    return this.http.post(environment.Api_edit_survey_answer_new, {
      answer: {
        id: answerId.toString(),
        answer: answer
      }
    });
  }

  /**
   * Agregar respuesta a pregunta
   */
  addSurveyAnswerNew(questionId: number, answers: string[]): Observable<any> {
    return this.http.post(environment.Api_add_survey_answer_new, {
      question_id: questionId,
      answers: answers
    });
  }

  /**
   * Eliminar pregunta
   */
  deleteSurveyQuestionNew(questionId: number): Observable<any> {
    return this.http.post(environment.Api_delete_survey_question_new, {
      question_id: questionId
    });
  }

  /**
   * Eliminar respuesta
   */
  deleteSurveyAnswerNew(answerId: number): Observable<any> {
    return this.http.post(environment.Api_delete_survey_answer_new, {
      answer_id: answerId
    });
  }

  /**
   * Exportar encuesta a Excel
   */
  exportSurveyToExcel(surveyId: number): Observable<Blob> {
    return this.http.get(`${environment.Api_export_survey_excel}${surveyId}/`, {
      responseType: 'blob'
    });
  }

  /**
   * Análisis detallado de texto
   */
  getDetailedTextAnalysis(questionId: number): Observable<any> {
    return this.http.get(`${environment.Api_detailed_text_analysis}${questionId}/`);
  }

  /**
   * Obtener encuesta para médico
   */
  getSurveyForMedic(surveyId: number): Observable<any> {
    return this.http.get(`${environment.Api_get_survey_for_medic}${surveyId}/`);
  }

  /**
   * Enviar respuesta de encuesta (médico)
   */
  submitSurveyResponse(responseData: SurveyResponse): Observable<any> {
    return this.http.post(environment.Api_submit_survey_response, responseData);
  }

  /**
   * Métodos de compatibilidad con la API antigua
   */
  createSurveyLegacy(title: string, description: string, all_medics: boolean, recipients_specialties: any[]): Observable<any> {
    return this.create_survey(title, description, all_medics, recipients_specialties);
  }

  listSurveysLegacy(filter: any, param: any, order: number, direction: number, page: number): Observable<any> {
    return this.list_surveys(filter, param, order, direction, page);
  }

  getSurveyDetailsLegacy(surveyId: number): Observable<any> {
    return this.list_idSurvey(surveyId);
  }

  /**
   * Método híbrido que detecta si usar API nueva o antigua
   */
  createSurveyHybrid(surveyData: CreateSurveyRequest, useNewApi: boolean = true): Observable<any> {
    if (useNewApi) {
      return this.createSurveyNew(surveyData);
    } else {
      return this.createSurveyLegacy(
        surveyData.title,
        surveyData.description,        // ✓ Segundo parámetro: description (string)
        surveyData.all_medics,         // ✓ Tercer parámetro: all_medics (boolean)
        surveyData.recipients_specialties  // ✓ Cuarto parámetro: recipients_specialties
      );
    }
  }

  /**
   * Método híbrido para listar encuestas
   */
  listSurveysHybrid(filter: string, param: string, order: number, direction: number, page: number, useNewApi: boolean = true): Observable<any> {
    if (useNewApi) {
      return this.listSurveysNew(filter, param, order, direction, page);
    } else {
      return this.listSurveysLegacy(filter, param, order, direction, page);
    }
  }

  /**
   * Método híbrido para obtener detalles de encuesta
   */
  getSurveyDetailsHybrid(surveyId: number, useNewApi: boolean = true): Observable<any> {
    if (useNewApi) {
      return this.getSurveyDetailsNew(surveyId);
    } else {
      return this.getSurveyDetailsLegacy(surveyId);
    }
  }

  listChallenges(page: number = 1, pageSize: number = 10, active?: boolean, challengeType?: string, search?: string): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', pageSize.toString());

    if (active !== undefined) {
      params = params.set('is_active', active.toString());
    }

    if (challengeType && challengeType !== '') {
      params = params.set('challenge_type', challengeType);
    }

    if (search && search.trim() !== '') {
      params = params.set('search', search.trim());
    }

    return this.http.get(environment.Api_challenges_list, { params });
  }

  /**
   * Crear challenge
   */
  createChallenge(challengeData: {
    name: string;
    description: string;
    challenge_type: string;
    target_value: number;
    points_reward: number;
    image?: File | string;
    is_active: boolean;
    is_monthly: boolean;
  }): Observable<any> {

    // Si la imagen es un string base64, enviar como JSON
    if (challengeData.image && typeof challengeData.image === 'string' && challengeData.image.startsWith('data:')) {
      console.log('📤 Enviando challenge como JSON (imagen base64)');

      const jsonData = {
        name: challengeData.name,
        description: challengeData.description,
        challenge_type: challengeData.challenge_type,
        target_value: challengeData.target_value,
        points_reward: challengeData.points_reward,
        is_active: challengeData.is_active,
        is_monthly: challengeData.is_monthly,
        image: challengeData.image // String base64 completo
      };

      return this.http.post(environment.Api_create_challenge, jsonData, {
        headers: {
          'Content-Type': 'application/json'
        },
        reportProgress: true,
        observe: 'events'
      });
    }

    // Si la imagen es un File o no hay imagen, usar FormData (método original)
    else {
      console.log('📤 Enviando challenge como FormData (archivo o sin imagen)');

      const formData = new FormData();

      formData.append('name', challengeData.name);
      formData.append('description', challengeData.description);
      formData.append('challenge_type', challengeData.challenge_type);
      formData.append('target_value', challengeData.target_value.toString());
      formData.append('points_reward', challengeData.points_reward.toString());
      formData.append('is_active', challengeData.is_active.toString());
      formData.append('is_monthly', challengeData.is_monthly.toString());

      if (challengeData.image && challengeData.image instanceof File) {
        formData.append('image', challengeData.image);
      }

      return this.http.post(environment.Api_create_challenge, formData, {
        reportProgress: true,
        observe: 'events'
      });
    }
  }

  /**
   * Obtener challenge específico
   */
  getChallenge(challengeId: number): Observable<any> {
    return this.http.get(`${environment.Api_challenge_detail}${challengeId}/`);
  }

  /**
   * Actualizar challenge
   */
  updateChallenge(challengeId: number, challengeData: {
    name?: string;
    description?: string;
    challenge_type?: string;
    target_value?: number;
    points_reward?: number;
    image?: File | string;
    is_active?: boolean;
    is_monthly?: boolean;
  }): Observable<any> {

    // Si la imagen es un string base64, enviar como JSON
    if (challengeData.image && typeof challengeData.image === 'string' && challengeData.image.startsWith('data:')) {
      console.log('📤 Actualizando challenge como JSON (imagen base64)');

      const jsonData: any = {};

      // Solo incluir campos que no sean undefined
      if (challengeData.name !== undefined) {
        jsonData.name = challengeData.name;
      }
      if (challengeData.description !== undefined) {
        jsonData.description = challengeData.description;
      }
      if (challengeData.challenge_type !== undefined) {
        jsonData.challenge_type = challengeData.challenge_type;
      }
      if (challengeData.target_value !== undefined) {
        jsonData.target_value = challengeData.target_value;
      }
      if (challengeData.points_reward !== undefined) {
        jsonData.points_reward = challengeData.points_reward;
      }
      if (challengeData.is_active !== undefined) {
        jsonData.is_active = challengeData.is_active;
      }
      if (challengeData.is_monthly !== undefined) {
        jsonData.is_monthly = challengeData.is_monthly;
      }

      // Agregar imagen base64
      jsonData.image = challengeData.image;

      return this.http.put(`${environment.Api_challenge_detail}${challengeId}/`, jsonData, {
        headers: {
          'Content-Type': 'application/json'
        },
        reportProgress: true,
        observe: 'events'
      });
    }

    // Si la imagen es un File o no hay imagen, usar FormData (método original)
    else {
      console.log('📤 Actualizando challenge como FormData (archivo o sin imagen)');

      const formData = new FormData();

      if (challengeData.name !== undefined) {
        formData.append('name', challengeData.name);
      }
      if (challengeData.description !== undefined) {
        formData.append('description', challengeData.description);
      }
      if (challengeData.challenge_type !== undefined) {
        formData.append('challenge_type', challengeData.challenge_type);
      }
      if (challengeData.target_value !== undefined) {
        formData.append('target_value', challengeData.target_value.toString());
      }
      if (challengeData.points_reward !== undefined) {
        formData.append('points_reward', challengeData.points_reward.toString());
      }
      if (challengeData.is_active !== undefined) {
        formData.append('is_active', challengeData.is_active.toString());
      }
      if (challengeData.is_monthly !== undefined) {
        formData.append('is_monthly', challengeData.is_monthly.toString());
      }

      if (challengeData.image && challengeData.image instanceof File) {
        formData.append('image', challengeData.image);
      }

      return this.http.put(`${environment.Api_challenge_detail}${challengeId}/`, formData, {
        reportProgress: true,
        observe: 'events'
      });
    }
  }

  /**
   * Eliminar challenge
   */
  deleteChallenge(challengeId: number): Observable<any> {
    return this.http.delete(`${environment.Api_challenge_detail}${challengeId}/`);
  }

  /**
   * Activar/desactivar challenge
   */
  toggleChallengeStatus(challengeId: number, isActive: boolean): Observable<any> {
    const formData = new FormData();
    formData.append('is_active', isActive.toString());

    return this.http.patch(`${environment.Api_challenge_detail}${challengeId}/`, formData);
  }

  /**
   * Convertir base64 a blob
   */
  private base64ToBlob(base64: string): Blob {
    const parts = base64.split(',');
    const contentType = parts[0].split(':')[1].split(';')[0];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
  }

  listBadges(page: number = 1, pageSize: number = 10, active?: boolean, search?: string): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', pageSize.toString());

    if (active !== undefined) {
      params = params.set('is_active', active.toString());
    }

    if (search && search.trim() !== '') {
      params = params.set('search', search.trim());
    }

    return this.http.get(environment.Api_badges_list, { params });
  }

  /**
   * Crear badge (ahora envía JSON en lugar de FormData)
   */
  createBadge(badgeData: {
    name: string;
    description: string;
    icon: string;
    color: string;
    points_reward: number;
    image?: string;
    is_active: boolean;
    requirements?: {
      referrals?: number;
      effective_rate?: number;
      points?: number;
      consecutive_days?: number;
      monthly_referrals?: number;
      monthly_effective_referrals?: number;
    };
  }): Observable<any> {
    const jsonData = {
      name: badgeData.name,
      description: badgeData.description,
      icon: badgeData.icon,
      color: badgeData.color,
      points_reward: badgeData.points_reward,
      image: badgeData.image || null,
      is_active: badgeData.is_active,
      requirements: badgeData.requirements || {}
    };

    return this.http.post(environment.Api_create_badge, jsonData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  /**
   * Actualizar badge (ahora envía JSON en lugar de FormData)
   */
  updateBadge(id: number, badgeData: {
    name: string;
    description: string;
    icon: string;
    color: string;
    points_reward: number;
    image?: string;
    is_active: boolean;
    requirements?: {
      referrals?: number;
      effective_rate?: number;
      points?: number;
      consecutive_days?: number;
      monthly_referrals?: number;
      monthly_effective_referrals?: number;
    };
  }): Observable<any> {
    const jsonData = {
      name: badgeData.name,
      description: badgeData.description,
      icon: badgeData.icon,
      color: badgeData.color,
      points_reward: badgeData.points_reward,
      image: badgeData.image || null,
      is_active: badgeData.is_active,
      requirements: badgeData.requirements || {}
    };

    return this.http.patch(`${environment.Api_badge_detail}${id}/`, jsonData, {
      reportProgress: true,
      observe: 'events'
    });
  }
  // Eliminamos el método base64ToBlob ya que no lo necesitaremos más

  /**
 * Obtener badge específico
 */
  getBadge(badgeId: number): Observable<any> {
    return this.http.get(`${environment.Api_badge_detail}${badgeId}/`);
  }

  /**
   * Eliminar badge
   */
  deleteBadge(badgeId: number): Observable<any> {
    return this.http.delete(`${environment.Api_badge_detail}${badgeId}/`);
  }

  /**
   * Activar/desactivar badge
   */
  toggleBadgeStatus(badgeId: number, isActive: boolean): Observable<any> {
    const formData = new FormData();
    formData.append('is_active', isActive.toString());

    return this.http.patch(`${environment.Api_badge_detail}${badgeId}/`, formData);
  }

  listMedals(page: number = 1, pageSize: number = 10, active?: boolean, medalType?: string, search?: string): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', pageSize.toString());

    if (active !== undefined) {
      params = params.set('is_active', active.toString());
    }

    if (medalType && medalType !== '') {
      params = params.set('medal_type', medalType);
    }

    if (search && search.trim() !== '') {
      params = params.set('search', search.trim());
    }

    return this.http.get(environment.Api_medals_list, { params });
  }

  /**
   * Crear medalla (ahora envía JSON en lugar de FormData)
   */
  /**
   * Crear medalla (simplificado sin requirements)
   */
  createMedal(medalData: {
    name: string;
    description: string;
    medal_type: string;
    referrals_required: number;
    image?: string;
    is_active: boolean;
  }): Observable<any> {
    const jsonData = {
      name: medalData.name,
      description: medalData.description,
      medal_type: medalData.medal_type,
      referrals_required: medalData.referrals_required,
      image: medalData.image || null,
      is_active: medalData.is_active
    };

    return this.http.post(environment.Api_create_medal, jsonData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  /**
   * Actualizar medalla (simplificado sin requirements)
   */
  updateMedal(medalId: number, medalData: {
    name?: string;
    description?: string;
    medal_type?: string;
    referrals_required?: number;
    image?: string;
    is_active?: boolean;
  }): Observable<any> {
    const jsonData: any = {};

    if (medalData.name !== undefined) jsonData.name = medalData.name;
    if (medalData.description !== undefined) jsonData.description = medalData.description;
    if (medalData.medal_type !== undefined) jsonData.medal_type = medalData.medal_type;
    if (medalData.referrals_required !== undefined) jsonData.referrals_required = medalData.referrals_required;
    if (medalData.is_active !== undefined) jsonData.is_active = medalData.is_active;
    if (medalData.image !== undefined) jsonData.image = medalData.image;

    return this.http.put(`${environment.Api_medal_detail}${medalId}/`, jsonData, {
      reportProgress: true,
      observe: 'events'
    });
  }


  /**
   * Obtener medal específica
   */
  getMedal(medalId: number): Observable<any> {
    return this.http.get(`${environment.Api_medal_detail}${medalId}/`);
  }


  /**
   * Eliminar medal
   */
  deleteMedal(medalId: number): Observable<any> {
    return this.http.delete(`${environment.Api_medal_detail}${medalId}/`);
  }

  /**
   * Activar/desactivar medal
   */
  toggleMedalStatus(medalId: number, isActive: boolean): Observable<any> {
    const formData = new FormData();
    formData.append('is_active', isActive.toString());

    return this.http.patch(`${environment.Api_medal_detail}${medalId}/`, formData);
  }

  getNotificationConfigurations(): Observable<any> {
    return this.http.get(environment.Api_notification_configurations_list);
  }

  /**
   * Crea una nueva configuración de notificación
   */
  createNotificationConfiguration(config: any): Observable<any> {
    return this.http.post(environment.Api_create_notification_configuration, config);
  }

  /**
   * Actualiza completamente una configuración (PUT)
   */
  updateNotificationConfiguration(id: number, config: any): Observable<any> {
    return this.http.put(`${environment.Api_notification_configuration_detail}${id}/`, config);
  }

  /**
   * Actualiza parcialmente una configuración (PATCH)
   */
  patchNotificationConfiguration(id: number, config: any): Observable<any> {
    return this.http.patch(`${environment.Api_notification_configuration_detail}${id}/`, config);
  }

  /**
   * Activa/desactiva una configuración
   */
  toggleNotificationConfiguration(id: number): Observable<any> {
    return this.http.post(`${environment.Api_notification_configuration_toggle}${id}/toggle/`, {});
  }

  /**
   * Elimina una configuración
   */
  deleteNotificationConfiguration(id: number): Observable<any> {
    return this.http.delete(`${environment.Api_notification_configuration_delete}${id}/eliminar/`);
  }

}
export interface SurveyQuestion {
  id: number;
  question: string;
  question_type: 'closed' | 'open' | 'categorized';
  specialty_filter?: string[];
}

export interface SurveyAnswer {
  id: number;
  answer: string;
  votes: number;
}

export interface Survey {
  id: number;
  title: string;
  description: string;
  active: boolean;
  date_created: string;
  all_medics: boolean;
  recipients_specialties: any[];
  total_questions?: number;
}

export interface SurveyDetails {
  survey: Survey;
  body: Array<{
    question: SurveyQuestion;
    answers: SurveyAnswer[];
    open_responses?: Array<{
      response_text: string;
      specialty: string;
      date_created: string;
    }>;
  }>;
}

export interface SurveyStatistics {
  survey_info: {
    id: number;
    title: string;
    description: string;
    total_questions: number;
  };
  questions_stats: Array<{
    question_id: number;
    question_text: string;
    question_type: string;
    specialty_filter?: string[];
    answers?: Array<{
      answer: string;
      votes: number;
      percentage: number;
    }>;
    total_votes?: number;
    total_responses?: number;
    responses_by_specialty?: any;
  }>;
}

export interface CreateSurveyRequest {
  title: string;
  description: string;
  all_medics: boolean;
  recipients_specialties: Array<{
    id: number;
    name: string;
  }>;
}

export interface CreateQuestionRequest {
  survey_id: number;
  items: Array<{
    question: string;
    question_type: 'closed' | 'open' | 'categorized';
    answers?: string[];
    specialty_filter?: string[];
  }>;
}

export interface SurveyResponse {
  survey_id: number;
  responses: Array<{
    question_id: number;
    question_type: string;
    answer_id?: number;
    response_text?: string;
  }>;
}


// Agregar estas interfaces al final del archivo admin.service.ts

export interface NotificationConfig {
  id: number;
  tipo_notificacion: string;
  tipo_notificacion_display: string;
  activo: boolean;
  dias_frecuencia: number;
  hora_envio: string;
  dias_anticipacion: number;
  ultimo_procesamiento?: string;
  total_envios_ultimo_procesamiento?: number;
  fecha_creacion: string;
  fecha_actualizacion: string;
}

export interface NotificationType {
  key: string;
  display: string;
  description: string;
  defaultConfig: {
    dias_frecuencia: number;
    hora_envio: string;
    dias_anticipacion: number;
  };
}

export interface NotificationConfigResponse {
  success: boolean;
  data: NotificationConfig[];
  message: string;
}

export interface CreateNotificationConfigRequest {
  tipo_notificacion: string;
  activo: boolean;
  dias_frecuencia: number;
  hora_envio: string;
  dias_anticipacion: number;
}

export interface UpdateNotificationConfigRequest {
  tipo_notificacion?: string;
  activo?: boolean;
  dias_frecuencia?: number;
  hora_envio?: string;
  dias_anticipacion?: number;
}

export interface ToggleNotificationResponse {
  success: boolean;
  data: {
    id: number;
    activo: boolean;
    tipo_notificacion: string;
  };
  message: string;
}
